import {
    SAMPLE_PREVIEW_URL,
    SAMPLE_PRODUCTS,
    SAMPLE_SOCIAL_NETWORKS,
    SAMPLE_WHATSAPP_NUMBER
} from "@/common/lib/onboarding-preview-samples";

const mutations = {
    SET_ONBOARDING_FLOW(state, payload) {
        state.onboardingFlow = payload;
    },
    SET_BUSINESS_TYPE(state, payload) {
        state.businessType = payload;
    },
    SET_COMPLETED_STEPS(state, payload) {
        state.completedSteps = payload || [];
    },
    SET_SELECTIONS(state, payload) {
        state.selections = payload || {};
    },
    SET_STEPPER_UI(state, payload) {
        state.stepperUi = { ...state.stepperUi, ...payload };
    },
    BUMP_NEXT_TOKEN(state) {
        state.requestNextToken += 1;
    },
    // El draft es lo que el usuario esta viendo/editando ahora mismo, separado
    // de `selections` (lo ultimo confirmado por el backend) para que un fetch
    // de status en paralelo nunca pise una edicion en curso. Solo se hidrata
    // una vez por sesion (`onboardingDraftHydrated`), para no perder ediciones
    // ya hechas al volver a un step ya visitado.
    HYDRATE_DRAFT(state, selections) {
        if (state.onboardingDraftHydrated) return;
        state.onboardingDraftHydrated = true;
        state.onboardingDraft = {
            logoIconUrl: selections?.logoIconUrl || "",
            stackColors: { ...(selections?.stackColors || {}) },
            businessDescription: selections?.businessDescription || "",
            socialNetworks: selections?.socialNetworks?.length
                ? [...selections.socialNetworks]
                : [...SAMPLE_SOCIAL_NETWORKS],
            whatsappNumber: selections?.whatsappNumber || "",
            customLinks: [],
            products: [],
            displayMode: selections?.displayMode || "catalog"
        };
    },
    SET_DRAFT_LOGO(state, logoIconUrl) {
        state.onboardingDraft.logoIconUrl = logoIconUrl;
    },
    SET_DRAFT_STACK_COLORS(state, stackColors) {
        state.onboardingDraft.stackColors = { ...stackColors };
    },
    SET_DRAFT_BUSINESS_DESCRIPTION(state, businessDescription) {
        state.onboardingDraft.businessDescription = businessDescription;
    },
    // La decision dummy-vs-real vive aca, no en la pagina: recibe que redes
    // eligio el usuario (con su baseUrl) y que escribio en cada una, y arma
    // la lista final. Sin ninguna red elegida, cae a la muestra generica; con
    // una red elegida pero sin usuario escrito, esa red usa la URL de
    // muestra fija; con usuario escrito, arma la URL completa.
    SET_DRAFT_SOCIAL_NETWORKS(state, { formData, selectedNetworks }) {
        if (!selectedNetworks?.length) {
            state.onboardingDraft.socialNetworks = [...SAMPLE_SOCIAL_NETWORKS];
            return;
        }
        state.onboardingDraft.socialNetworks = selectedNetworks.map(
            (network) => {
                const typed = (formData?.[network.key] || "").trim();
                return {
                    network: network.key,
                    url: typed ? network.baseUrl + typed : SAMPLE_PREVIEW_URL
                };
            }
        );
    },
    // WhatsApp no viaja dentro de `socialNetworks` (es un boton propio en el
    // preview, no un icono mas), asi que necesita su propia logica dummy-vs-
    // real: sin seleccionar, sin numero; seleccionado sin numero aun, un
    // numero de muestra para que el boton ya aparezca; con numero escrito, el
    // real (completo, con indicativo).
    SET_DRAFT_WHATSAPP(state, { selected, value }) {
        if (!selected) {
            state.onboardingDraft.whatsappNumber = "";
            return;
        }
        const typed = (value || "").trim();
        state.onboardingDraft.whatsappNumber = typed || SAMPLE_WHATSAPP_NUMBER;
    },
    SET_DRAFT_CUSTOM_LINKS(state, customLinks) {
        state.onboardingDraft.customLinks = [...(customLinks || [])];
    },
    // Si el producto real no trae fotos, se le asigna una de muestra (mismo
    // set que SAMPLE_PRODUCTS) para que el preview nunca muestre un producto
    // sin imagen.
    ADD_DRAFT_PRODUCT(state, product) {
        const products = state.onboardingDraft.products;
        const hasImages = Boolean(product.references?.[0]?.images?.length);
        const finalProduct = hasImages
            ? product
            : {
                  ...product,
                  references: [
                      {
                          ...product.references?.[0],
                          images: [
                              {
                                  url: SAMPLE_PRODUCTS[
                                      products.length % SAMPLE_PRODUCTS.length
                                  ].references[0].images[0].url
                              }
                          ]
                      }
                  ]
              };
        products.push(finalProduct);
    }
};

export default mutations;
